// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenSquareFilledSvg from "@fishx/icons-svg/es/asn/CodepenSquareFilled";
import FishxIcon from '../components/FishxIcon';

var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenSquareFilledSvg
  }));
};

CodepenSquareFilled.displayName = 'CodepenSquareFilled';
export default React.forwardRef(CodepenSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodepenSquareFilled.js
// module id = 2279
// module chunks = 0